export { et } from '@payloadcms/translations/languages/et'
